// InDesign repeats a frame's class on the image and the text inside it, so every getData module would
// pick the same item up twice. Only the frame counts, the copies inside it are removed here.

const pluginClassPrefixes = [
	'plugin-enrichment-',
	'plugin-slider-',
	'plugin-animationScrollableBox-',
	'editable-plugin-slider-',
	'editable-text-',
	'editable-image-',
	'editable-video-',
	'editable-animation-',
	'editable-button-',
	'responsiveItem-',
	'webPublication-theme-color-',
];

const lockedItemClass = /^\d+_\d+/;
const dynamicContentClass = /^_\d+_\d+/;
// the class the plugin builds from getUniqueId() for the name a designer typed in the panel
const uniqueIdClass = /^\d{13}_\d+-/;

const isPluginClass = (className: string): boolean => {
	if (pluginClassPrefixes.some(prefix => className.indexOf(prefix) === 0)) {
		return true;
	}

	return (lockedItemClass.test(className) && className.includes('-locked')) ||
		dynamicContentClass.test(className) ||
		uniqueIdClass.test(className);
};

// a class name can hold text the designer typed, so it is never put into a selector
const hasAncestorWithClass = (element: HTMLElement, className: string): boolean => {
	let ancestor = element.parentElement;

	while (ancestor) {
		if (ancestor.classList.contains(className)) {
			return true;
		}

		ancestor = ancestor.parentElement;
	}

	return false;
};

export default (htmlDocument: Document): Document => {
	const elements = [...htmlDocument.querySelectorAll('[class]')] as HTMLElement[];

	elements.forEach((element) => {
		[...element.classList].forEach((className) => {
			if (isPluginClass(className) && hasAncestorWithClass(element, className)) {
				element.classList.remove(className);
			}
		});
	});

	return htmlDocument;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/dropRepeatedPluginClasses.ts